export const IsTruthy = (value: unknown) => !!value;
export const Equals = (value: unknown) => (compare: unknown) => value === compare;
export const NotEquals = (value: unknown) => (compare: unknown) => value !== compare;
export const SortAlphabetically = (a: string, b: string) => a.localeCompare(b);
export const SortAlphabeticallyWithKey = <T,>(key: keyof T) => (a: T, b: T) => (a[key] as string).localeCompare(b[key] as string);